import * as actionTypes from './actionTypes';

/**
* @desc actions for candidate talentPool reducer
* @version
* @author  Lakshmikanth
* @return action and parameters
*/
export const getTalentPool = (jobTitleId,user) => {
  return {
    type: actionTypes.GET_TALENTPOOL,
    jobTitleId:jobTitleId,
    user:user
  };
};

export const setTalentPool = ( talentPool, isClient ) => {
  return {
    type: actionTypes.SET_TALENTPOOL,
    talentPool: talentPool,
    isClient: isClient
  };
};

export const viewCandidate = (candidateId,jobtitleId) => {
  return {
    type: actionTypes.VIEW_CANDIDATE,
    candidateId: candidateId,
    jobtitleId:jobtitleId
  };
};

export const setJobList = ( jobList ) => {
  return {
    type: actionTypes.SET_JOBLIST,
    jobList: jobList,
  };
};

export const setJobTitle = ( jobtitleId,jobTitle, jobBHID, companyType ) => {
  return {
    type: actionTypes.SET_JOBTITLE,
    jobTitleId: jobtitleId,
    jobTitle : jobTitle,
    jobBHID : jobBHID,
    companyType: companyType
  };
};

export const getTalentPoolRecruiter = (jobTitleId,user) => {
  return {
    type: actionTypes.GET_TALENTPOOL_RECRUITER,
    jobTitleId:jobTitleId,
    user:user
  };
};

export const setCurrentRole = ( candidateId, currentJobTitle, currentEmployer) => {
  return {
    type: actionTypes.SET_CURRENT_ROLE,
    candidateId: candidateId,
    currentJobTitle: currentJobTitle,
    currentEmployer: currentEmployer
  };
};

export const setCandidateProfileEdit = ( candidateId, candidateName,candidateInitials, candidateEmail,candidateNoticeperiod,candidateJobtype) => {
  return {
    type: actionTypes.SET_CANDIDATE_PROFILE_EDIT,
    candidateId: candidateId,
    candidateName: candidateName,
    candidateInitials: candidateInitials,
    candidateEmail:candidateEmail,    
    candidateNoticeperiod:candidateNoticeperiod,
    candidateJobtype:candidateJobtype
  };
};

export const signOutTalentPool = () => {
  return {
    type: actionTypes.COGNITO_LOGOUT
  };
};

export const clearTalentPoolRecruiter = () => {
  return {
    type: actionTypes.CLEAR_TALENT_POOL
  };
};

export const importCandidateRecruiter = (candidate) => {
  return {
    type: actionTypes.IMPORT_CANDIDATE_RECRUITER,
    candidate:candidate
  };
};

export const removeCandidateRecruiter = ( candidateIndex ) => {
  return {
    type: actionTypes.REMOVE_CANDIDATE_RECRUITER,
    candidateIndex: candidateIndex
  };
};

export const viewCandidateRecruiter = (candidateId, jobTitleId,user) => {
  return {
    type: actionTypes.VIEW_CANDIDATE_RECRUITER,
    candidateId: candidateId,
    jobTitleId: jobTitleId,
    user:user
  };
};

export const setPermittedContact = ( permittedContact ) => {
  return {
    type: actionTypes.SET_PERMITTED_CONTACT,
    permittedContact: permittedContact
  }
}

export const setEditStatus = (candidateId, editStatus) => {
  return {
    type: actionTypes.SET_CANDIDATE_EDIT_STATUS,
    candidateId:candidateId,
    editStatus:editStatus
  };
}

export const updateCandidatePublished = ( ) => {
  return {
    type: actionTypes.UPDATE_CANDIDATE_PUBLISHED
  }
}

export const setCandidateCardProfileImage = (s3SignedUrl,candidateId,candidateImage) => {
  return {
    type: actionTypes.SET_CANDIDATE_CARD_IMAGE,
    candidateImage:candidateImage,
    candidateId:candidateId,
    s3SignedUrl:s3SignedUrl
  }
}

export const setProgressNotification = (showProgressNotification) => {
  return {
    type: actionTypes.SET_PROGRESS_NOTIFICATION,
    showProgressNotification: showProgressNotification
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/talentPool.js